import { SettingCard, SettingCardRow } from '@components/Dashboard/components'
import { Switch } from '@lib/components'
import type { MailTopic } from '@store/reducers/account'
import type React from 'react'

import { Divider } from '../../../../components/Divider'
import css from './styles.module.css'
import { useEmailChoices } from './useEmailChoices'

// Monthly recap (`recap`) stays hidden until the first recap letters go out
// (Karl, 14.10.2026)
const groups: { topic: MailTopic; label: string }[] = [
  { topic: 'onboarding', label: 'Onboarding' },
  { topic: 'tips', label: 'Tips and tricks' },
  { topic: 'news', label: 'Product updates' },
]

export const EmailsSection: React.FC = () => {
  const { choices, update } = useEmailChoices()

  // Nothing to show until SES answers: a switch that guesses is worse than
  // none
  if (!choices) {
    return null
  }

  return (
    <div className={css.section}>
      <SettingCard title="Emails">
        <div className={css.rows}>
          {groups.map(({ topic, label }) => (
            <SettingCardRow key={topic} title={label} titleCenter>
              {/* While All emails is off a group keeps its own choice, greyed
                out: it applies again once All emails is back on */}
              <Switch
                checked={choices.topics[topic]}
                disabled={!choices.all}
                onChange={(checked: boolean) =>
                  update({ topics: { [topic]: checked } })
                }
              />
            </SettingCardRow>
          ))}
        </div>

        <Divider />

        <SettingCardRow title="All emails" titleCenter>
          <Switch
            checked={choices.all}
            onChange={(checked: boolean) => update({ all: checked })}
          />
        </SettingCardRow>
      </SettingCard>

      <div className={css.caption}>
        Account emails like sign-in codes and payment notices are always sent.
      </div>
    </div>
  )
}
